/* Prepinac svetly / tmavy rezim */
(function () {
  if (window.__vhScheme) return;
  window.__vhScheme = true;

  var KEY = 'vh-scheme';

  function store(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  function current() {
    return document.documentElement.getAttribute('data-scheme') === 'dark' ? 'dark' : 'light';
  }

  function bind(btn) {
    if (btn.__vhBound) return;
    btn.__vhBound = true;
    btn.setAttribute('aria-pressed', current() === 'dark' ? 'true' : 'false');
    btn.addEventListener('click', function () {
      var next = current() === 'dark' ? 'light' : 'dark';
      document.documentElement.setAttribute('data-scheme', next);
      store(next);
      Array.prototype.forEach.call(document.querySelectorAll('.vh-scheme'), function (b) {
        b.setAttribute('aria-pressed', next === 'dark' ? 'true' : 'false');
      });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.vh-scheme'), bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
